function MinusIcon() {
  return (
    <svg fill="none" width="64px" height="64px" viewBox="0 0 24 24" class="icon glyph" stroke="none">
      <g>
        <path d="M19,13H5a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z" />
      </g>
    </svg>
  );
}

export default MinusIcon;